import React, { FunctionComponent } from 'react'
import { useRouteMatch } from 'react-router-dom'

import TableContext, {
  createTableContext,
} from '../../../../contexts/TableContext'
import Table from './Table'

export type DetailsSorts =
  | 'adjustments'
  | 'commission'
  | 'programName'
  | 'processedAt'
  | 'productName'
  | 'total'
  | 'paymentId'

export interface DetailsFilters {}

export const DetailsTableContext = createTableContext<
  DetailsFilters,
  DetailsSorts
>()

interface DetailsContainerMatchParams {
  paymentId: string
}

const DetailsContainer: FunctionComponent = () => {
  const { params } = useRouteMatch<DetailsContainerMatchParams>()

  return (
    <TableContext<DetailsFilters, DetailsSorts>
      Context={DetailsTableContext}
      defaultSort={{
        by: 'processedAt',
        dir: 'desc',
      }}
      defaultPagination={{
        page: 1,
        size: 10,
      }}
    >
      <Table paymentId={params.paymentId} />
    </TableContext>
  )
}

export default DetailsContainer
